import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import WeekForm from './WeekForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

class WeekDialog extends Component {
    constructor(props) {
        super(props);
    }

    dialogConfig() {
        const { t, onCancel, week } = this.props;

        return {
            header: week ? `${t('Workshop_Week')}: ${moment(week.startDate).format('LL, dddd')} - ${moment(week.endDate).format('LL, dddd')}` : t('Workshop_Add_Week') ,
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm, week } = this.props;     
        return <WeekForm onSubmit={onConfirm} initialValues={week} />;       
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='week' label={t('Common_Save')} />;
        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

WeekDialog.propTypes = {
    show: PropTypes.bool,
    to: PropTypes.array,
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(WeekDialog);